module.exports = __webpack_public_path__ + "img/team-1.b7d542e8.png";